jQuery_T4NT(document).ready(function($) {
    console.log("jQuery_T4NT ready");
     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
     $( document ).on( "variant:changed", function( evt ) {
       // console.log( evt.currentVariant );
       // $('[data-variant-toggle]').hide(0);
       // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
     });

      let validated = false;

      $( '.t4s-pr-item-btn' ).on('click', function(e){
          //e.stopPropagation();
          //e.preventDefault();
          console.log("Click from custom from atc 2");
          if($(this).attr("data-action-atc") !== undefined){
            if(!validated){
                //var tags = $(this).closest(".t4s-product-btns").data("tags")
                var tags = $(this).closest(".t4s-product-btns").data("vendor");

                console.log("Click from custom from atc", tags);
                if(tags.includes("Bukz España") || tags.includes("Bukz USA")){
                    e.stopPropagation();
                    e.preventDefault();
    
                    Swal.fire({
                      title: "¡Hey! Estás agregando un libro importado 🎉📚",
                      html: "Solo para que tengas en cuenta: se te puede demorar <b>30 días hábiles.</b>",
                      showCancelButton: true,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#d33',
                      confirmButtonText: '¡Sí, espero!',
                      cancelButtonText: 'Nah, mejor no',
                      focusconfirm: false,                  
                      allowOutsideClick: false
                    }).then((result) => {
                      validated = true;
                      if (result.isConfirmed) {
                        $(this).trigger('click');
                      } else {
                        validated = false;
                      }
                    });  
                    //return false;
                }
            } else {
              validated = false;
            }
            //e.preventDefault();
            
            //return false;
          }
      });

      $(".snize-add-to-cart-button").on('click', function(e){
          console.log("click search");
      })
      
});


